const getDetailsModuleAssetUrl = () => {
	return new Worker(new URL("../../workers/orderDetailsPDFWorker.worker.tsx", import.meta.url), { type: "module" });
};

export default getDetailsModuleAssetUrl;
